import { CheckCircle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { getEquipmentLabel } from "@/i18n";

interface EquipmentItemProps {
  item: string;
}

const EquipmentItem = ({ item }: EquipmentItemProps) => {
  const { language } = useLanguage();
  const displayLabel = getEquipmentLabel(item, language);
  return (
    <div className={`flex items-start p-1.5 gap-2 md:gap-3 min-w-0`}>
      <CheckCircle className="w-4 h-4 md:w-6 md:h-6 text-green-500 flex-shrink-0 mt-0.5" />
      <span className="text-base md:text-sm text-foreground break-words overflow-wrap-anywhere hyphens-auto min-w-0 flex-1 leading-tight">
        {displayLabel}
      </span>
    </div>
  );
};

export default EquipmentItem;
